module.exports = __webpack_public_path__ + "img/triangle--dark--down.3e6706f7.svg";